import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NavigateButton from "../../../Components/UI/Buttons/NavigateButton";
import BasicTable from "../../../Components/Table/Material";
import useApi from "../../../Hooks/useApi";
import Tooltip from "@mui/material/Tooltip";
import { usePagination } from "../../../Hooks/usePagination";

import { SVG_DATA_UPLOAD } from "../../../Assets/SVG/svg_util";
import Common from "../../../Components/Layouts/Common";

const SurveyDataSubmissionCityList = () => {
  const { t } = useTranslation();
  const { request } = useApi();
  const navigate = useNavigate();
  const paginateProps = usePagination();

  const location = useLocation();
  const { surveyId, surveyName, questionId } = location?.state || {};
  const [surveyCityList, setSurveyCityList] = useState();
  const [data, setData] = useState();

  const buttonConfigs = [
    {
      Icon: SVG_DATA_UPLOAD,
      tooltip: (row) =>
        row.status === "SUBMITTED" ? "Already Data Uploated" : "Upload Data",
      bgColor: (row) =>
        row.status === "SUBMITTED"
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-[#1976d2]",
      onClick: (navigate, row) => () => {
        if (row.status !== "SUBMITTED") {

          navigate(`/survey-data-submission`, {
            state: {
              surveyId: surveyId,
              surveyName: surveyName,
              city: row.name,
              id: row.id,
              questionId: questionId,
              answerType: data.answerType,
              locationId: row.id,
            },
          });
        }
      },
    },
  ];

  const fetchSurveyCityList = async () => {
    try {
      const response = surveyId
        ? await request(
            "GET",
            `/v1/survey/city-mapping/${surveyId}`,
            {},
            "survey_service"
          )
        : undefined;
      setData(response);
      setSurveyCityList(response.cities);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSurveyCityList();
  }, []);

  const columns = [
    {
      id: "name",
      label: "City Name",
      minWidth: 170,
    },
    {
      id: "creationDate",
      label: "Assigned Date",
      minWidth: 100,
    },
    {
      id: "status",
      label: "Data Submission Status",
      minWidth: 100,
    },

    {
      id: "action",
      label: "Actions",
      minWidth: 170,
      align: "center",
      renderCell: (row) => {
        return (
          <div className="inline-flex space-x-2">
            {buttonConfigs.map(
              ({ Icon, tooltip, bgColor, onClick }, buttonIndex) => (
                <Tooltip title={tooltip(row)}>
                  <button
                    key={buttonIndex}
                    onClick={onClick(navigate, row)}
                    className={`${bgColor(
                      row
                    )} border border-gray-300 h-8 w-8 text-white rounded-md flex items-center justify-center p-1`}
                  >
                    <Icon />
                  </button>
                </Tooltip>
              )
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    if (!surveyId) {
      navigate("/manage-survey");
    }
  }, [surveyId]);

  return (
    <Common headline={"Survey Data Submission City List"}>
      <div className=" bg-white  relative">
        <div className="flex mb-4 ">
          <h4 className=" font-bold text-gray-800 pr-2">Survey Name:</h4>
          <h5>{surveyName}</h5>
        </div>
        {/* <div className="py-2 flex items-center justify-between">
        <div className="space-x-2">
          <Link to={"/select-survey-questionnaire-method"}>
            <Button variant="contained">Add New Survey Questionnaire</Button>
          </Link>
          <Button>Export</Button>
          <Button>Print</Button>
        </div>
      </div> */}

        <BasicTable
          columns={columns}
          data={surveyCityList}
          paginateProps={paginateProps}
        />
      </div>
    </Common>
  );
};

export default SurveyDataSubmissionCityList;
